import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import largeBg from '@propertypal/shared/src/resources/images/mortgages/ppm-desktop.jpg';
import smallBg from '@propertypal/shared/src/resources/images/mortgages/ppm-mobile.jpg';
import styled from 'styled-components';

const MortgageJumboTronContainer = styled.section`
  background-image: url(${largeBg.src});
  background-size: cover;
  background-position: center;
  min-height: 760px;
  position: relative;
  overflow: hidden;

  & > svg {
    margin-top: 30px;
  }

  h1 {
    color: ${(props) => props.theme.white};
    font-size: 72px;
    max-width: 380px;
    line-height: 72px;
    margin-top: 50px;
  }

  h2 {
    color: ${(props) => props.theme.textDark};
    font-size: 28px;
    max-width: 580px;
    margin-top: 30px;

    b {
      font-weight: 900;
    }
  }

  a {
    display: block;
    max-width: 250px;
    width: 100%;
    margin-top: 60px;
  }

  @media (${laptopMediumMax}) {
    min-height: 700px;

    h1 {
      font-size: 58px;
      line-height: 64px;
    }

    h2 {
      font-size: 20px;
      max-width: 420px;
    }
  }

  @media screen and (${mobileXXLargeMax}) {
    min-height: 680px;
    background-image: url(${smallBg.src});
    background-position: center bottom;

    & > svg {
      margin-top: 15px;
    }

    h1 {
      font-size: 36px;
      line-height: 36px;
      text-align: center;
      max-width: initial;
      margin-top: 30px;
    }

    h2 {
      text-align: center;
      font-size: 20px;
      margin-top: 15px;
    }

    a {
      margin-top: 30px;
    }
  }
`;

const MortgageJumboTronFooter = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const MortgageJumboTronInner = styled.div<{ isMortgageLanding?: boolean }>`
  padding: 40px 30px 20px;
  max-width: ${(props) => (props.isMortgageLanding ? '1440' : '2560')}px;
  margin: 0 auto;

  @media (${laptopMediumMax}) {
    padding: 40px 15px 20px;
  }

  @media screen and (${mobileXXLargeMax}) {
    padding: 0;
    margin: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export { MortgageJumboTronContainer, MortgageJumboTronFooter, MortgageJumboTronInner };
